const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

function authHeaders() {
  const token = localStorage.getItem('ensight_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const getAvailableModels = async () => {
  const response = await fetch(`${API_BASE_URL}/available_models`, { headers: authHeaders() });
  if (!response.ok) throw new Error("Failed to fetch models");
  const data = await response.json();
  return data.models;
};

export const getSettings = async () => {
  const response = await fetch(`${API_BASE_URL}/settings`, { headers: authHeaders() });
  if (!response.ok) throw new Error("Failed to fetch settings");
  return response.json();
};

export const updateSettings = async (settings) => {
  const formData = new FormData();
  if (settings.ai_provider)       formData.append("ai_provider",       settings.ai_provider);
  if (settings.google_api_key)    formData.append("google_api_key",    settings.google_api_key);
  if (settings.openai_api_key)    formData.append("openai_api_key",    settings.openai_api_key);
  if (settings.anthropic_api_key) formData.append("anthropic_api_key", settings.anthropic_api_key);
  if (settings.model_version)     formData.append("model_version",     settings.model_version);
  if (settings.embedding_model)   formData.append("embedding_model",   settings.embedding_model);
  if (settings.email_whitelist !== undefined) formData.append("email_whitelist", settings.email_whitelist);

  const response = await fetch(`${API_BASE_URL}/update_settings`, {
    method: "POST",
    headers: authHeaders(),
    body: formData,
  });
  return response.ok;
};
